import { Icon, IconProps } from '@mui/material'
import React from 'react'

export type WcIconProps = IconProps

export const WcIcon = ({ children,...props}: WcIconProps) => (
    <Icon {...props}>{children}</Icon>
  )